global.baseUrl = "https://api.geoticket.it/";


global.getFormData = function (object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => {
        // if (object[key] !== null)
        formData.append(key, object[key])
    });
    // console.log("formData")
    // console.log(formData)
    return formData;
};
